export class SoundEffect {
  constructor(file) {
    const audio = new Audio()
    audio.type = 'audio/mp3'
    audio.src = `https://storage.googleapis.com/wcam-27caf.appspot.com/public/sound/${file}.mp3`
    audio.onloadedmetadata = () => {
      this.audio = audio
      // audio.playbackRate = 2
    }
  }

  play() {
    if (!this.audio) {
      console.warn('audio not loaded yet')
    }
    if (window.mute) {
      return
    }

    this.audio.currentTime = 0
    this.audio.play().catch((err) => {
      console.warn(err)
    })
  }

}



// WEBPACK FOOTER //
// ./src/components/common/SoundEffect.js